import i18n from 'i18n-client'
import {addRequiredValidation} from './utils'

export const ruleRunner =
  (field, name, ...validations) =>
  state => {
    for (const v of validations) {
      const errorMessageFunc = v(state[field], state)
      if (typeof errorMessageFunc === 'function') {
        return {[field]: errorMessageFunc(i18n.t(name))}
      }
    }
    return null
  }

export const profileRuleRunner = (field, name, data = {}, ...validationFunctions) => {
  validationFunctions = addRequiredValidation(validationFunctions, field, data[field])
  return ruleRunner(field, name, ...validationFunctions)
}

export const run = (state, runners) => runners.reduce((memo, runner) => ({...memo, ...runner(state)}), {})
